import { Button, Col, Row, Tooltip } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { products } from "../../../services";
import ProductGiftsModal from "./productGiftsModal";
import _ from "lodash";
import "./style.scss";
import { DefaultImg } from "../../images";
import { useTranslation } from "react-i18next";
import { InfoCircleOutlined } from "@ant-design/icons";
import { checkGiftHaveReselect } from "../../../shared/helpers";
import ProductImagesPreviewModal from "./productImagesPreviewModal";

const service = products;

const ProductGifts = (props: any) => {
  const { productInfo, quantity, handleChangeGift } = props;
  const [productGifts, setProductGifts] = useState<any>({});
  const [visible, setVisible] = useState(false);
  const [isShowImgs, setIsShowImgs] = useState(false);
  const [promotion, setPromotion] = useState<any>([]);
  const [giftSelected, setGiftSelected] = useState<any>({});
  const [previewImg, setPreviewImg] = useState<any>(null);
  const [listPreviewImg, setListPreviewImg] = useState<string[] | null>(null);
  const { t } = useTranslation();
  const timeRef = useRef<any>(null);

  useEffect(() => {
    if (timeRef && timeRef.current) {
      clearTimeout(timeRef.current);
    }

    timeRef.current = setTimeout(() => {
      service.getProductPromotion(
        { code: productInfo.value, quantity },
        (data: any, err: any) => {
          if (data) {
            setProductGifts({
              ...data,
              promotion_products: data.promotion_products.map(
                (p: any, i: number) => ({ ...p, id: i })
              ),
            });
            // setPromotion(data.promotion_products[0]);
            setGiftSelected({
              ...{},
              0: true,
              currentId: 0,
              data: { ...data.promotion_products[0], id: 0 },
            });
            setPreviewImg(data.promotion_products[0].img || DefaultImg);
            if (
              data.promotion_products[0].imgs &&
              data.promotion_products[0].imgs.length
            ) {
              setListPreviewImg(data.promotion_products[0].imgs);
            }
          }
        }
      );
    }, 1000);
  }, [productInfo, quantity]);

  // componentWillUnmount
  useEffect(() => {
    return () => {
      if (timeRef && timeRef.current) {
        clearTimeout(timeRef.current);
      }
    };
  }, []);

  const showModal = () => {
    const index = giftSelected.currentId;
    setVisible(true);
    setPromotion(productGifts.promotion_products[index]);
  };

  const handleClose = () => setVisible(false);

  const handleCloseImgsPreview = () => setIsShowImgs(false);

  const handleChange = (featureId: any, newOpt: any) => {
    const curProductGifts = _.clone(productGifts);

    const index = giftSelected.currentId;

    if (index > -1) {
      curProductGifts.promotion_products[index].default_prop = newOpt.spec_id;
      curProductGifts.promotion_products[index].pattern = newOpt.name;
      curProductGifts.promotion_products[index].img = newOpt.img;
    }

    handleChangeGift(curProductGifts);
    setProductGifts(curProductGifts);
    setVisible(false);
    setPreviewImg(curProductGifts.promotion_products[index].img || DefaultImg);
  };

  const handleChoose = (gift: any) => {
    setGiftSelected({ ...{}, [gift.id]: true, currentId: gift.id, data: gift });
    setPreviewImg(gift.img || DefaultImg);
    setListPreviewImg(gift.imgs);

    if (gift.imgs && gift.imgs.length) {
      setIsShowImgs(true);
    }
  };

  const showGifts = () =>
    productGifts?.promotion_products?.length
      ? productGifts?.promotion_products?.map((g: any, i: number) => {
          // Hard code:
          // dùng key `check_inventory` để check xem có phải drap không (hiện tại mỗi drap bật check_inventory)
          // replace 160 x 200 x 20cm -> 160 x 200 cm
          const note =
            g.check_inventory && g.note
              ? `${g.note.split("x").slice(0, 2).join(" x ")}`
              : g.note;

          return (
            <Tooltip title={`${g.name} (${g.note})`} id={g.id}>
              <a
                className={`product-gift-item-wrapper ${
                  giftSelected[g.id] ? "active" : ""
                }`}
                onClick={() => handleChoose(g)}>
                <Row
                  align="middle"
                  justify="end"
                  style={{ flexWrap: "nowrap" }}>
                  <Col flex="auto">
                    <Row className="main-content gift-name" justify="start">
                      <span>{g.name}</span>
                    </Row>
                    <Row className="sub-content gift-note" justify="start">
                      <span>{note}</span>
                    </Row>
                  </Col>
                  <Col>
                    <Row align="middle" style={{ flexWrap: "nowrap" }}>
                      <Col>
                        <Row align="middle">
                          <img
                            className="gift-image"
                            src={g.img ? g.img : DefaultImg}
                          />
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </a>
            </Tooltip>
          );
        })
      : null;

  return productGifts?.promotion_products?.length ? (
    <Row align="top" justify="center" className="product-gift-wrapper">
      <Col span={24}>
        {/* <Col sm={24} xl={24} xxl={24}> */}
        <Row align="top" justify="space-between" style={{ flexWrap: "nowrap" }}>
          <Col className="main-content gift-title">
            {t("label_gifts_title")}
          </Col>
          <Col flex="auto">{showGifts()}</Col>
        </Row>
        <Row className="product-gift-preview-img-wrapper" justify="center">
          <Col>
            <div>
              {giftSelected["data"] && giftSelected["data"]?.options?.length ? (
                <Button className="btn-re-choose" onClick={showModal}>
                  <span>{t("label_reselect")}</span>
                </Button>
              ) : null}
            </div>
            {(!listPreviewImg || !listPreviewImg.length) && (
              <img src={previewImg} alt="" />
            )}
            {checkGiftHaveReselect(productGifts.promotion_products) ? (
              <Row justify="start">
                <p
                  className="sub-content"
                  style={{ margin: "10px 0", color: "#a19d95" }}>
                  <span className="main-content" style={{}}>
                    <InfoCircleOutlined />
                  </span>{" "}
                  Quý khách có thể chọn lại quà tặng hoặc màu sắc hoa văn
                </p>
              </Row>
            ) : null}
          </Col>
        </Row>
      </Col>
      <ProductGiftsModal
        handleClose={handleClose}
        handleChange={handleChange}
        promotion={promotion}
        visible={visible}
      />
      <ProductImagesPreviewModal
        handleClose={handleCloseImgsPreview}
        visible={isShowImgs}
        listPreviewImg={listPreviewImg || []}
      />
    </Row>
  ) : null;
};

export default ProductGifts;
